<template>
  <div>
    <!--4项重要数据展示-->
    <div>
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="card" style="background: linear-gradient(270deg, #FFC3B3 0%, #FF8562 100%);">
            <div class="cardFont" style="font-size:22px">
              <span v-if="deviceInfo.lockMark==null">未知</span>
              <span v-else-if="deviceInfo.lockMark">锁定</span>
              <span v-else-if="!deviceInfo.online">离线</span>
              <span v-else-if="deviceInfo.status">开机</span>
              <span v-else>关机</span>
            </div>
            <div class="cardFont">设备状态</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="card"
            style="background: linear-gradient(270deg, #FFFFFF 0%, #F9F9F9 0%, #FAE5A3 0%, #F5B800 100%);"
          >
            <div
              class="cardFont"
              style="font-size:22px"
            >{{getStandardDate(new Date(deviceInfo.expires))}}</div>
            <div class="cardFont">实际到期日期</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="card" style="background: linear-gradient(270deg, #76F7B5 0%, #1AD276 100%);">
            <div
              class="cardFont"
              style="font-size:22px"
            >{{JSON.parse(waterPurifyInfo.tdsValues)[0]}}PPM</div>
            <div
              class="cardFont"
            >{{waterPurifyInfo.tdsNames!=null?waterPurifyInfo.tdsNames.split(",")[0]:"TDS1"}}</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="card" style="background: linear-gradient(270deg, #A2CEFC 0%, #248BF8 100%);">
            <div
              class="cardFont"
              style="font-size:22px"
            >{{JSON.parse(waterPurifyInfo.tdsValues)[1]}}PPM</div>
            <div
              class="cardFont"
            >{{waterPurifyInfo.tdsNames!=null?waterPurifyInfo.tdsNames.split(",")[1]:"TDS2"}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--基础数据展示-->
    <div style="margin-top:2%;">
      <el-card body-style="height:230px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-row>
              <el-col :span="10" style="text-align: center;">
                <img
                  @load="setSize($event,220,220)"
                  :src="deviceInfo.image"
                  :style="{width: imgWidth + 'px', height: imgHeight + 'px'}"
                />
              </el-col>
              <el-col :span="14" style="padding-left:15px">
                <el-row class="info-item">
                  <el-col :span="7" class="info-name">序列号：</el-col>
                  <el-col
                    :span="17"
                  >{{deviceInfo.sn}}{{deviceInfo.sn!=deviceInfo.nickname?"("+deviceInfo.nickname+")":""}}</el-col>
                </el-row>
                <el-row class="info-item">
                  <el-col :span="7" class="info-name">用户：</el-col>
                  <el-col
                    :span="17"
                  >{{deviceInfo.endUserNickname?deviceInfo.endUserNickname+"("+usernameToPhone(deviceInfo.endUsername)+")":""}}</el-col>
                </el-row>
                <el-row class="info-item">
                  <el-col :span="7" class="info-name">代理商：</el-col>
                  <el-col :span="17">{{deviceInfo.name}}</el-col>
                </el-row>
                <el-row class="info-item">
                  <el-col :span="7" class="info-name">授权员工：</el-col>
                  <el-col :span="17">
                    <span>{{sharedUser.nickname}}</span>
                    <el-button
                      style="background: #FFFFFF;border: 1px solid #16ACF0;opacity: 1;border-radius: 33px;align: center;line-height: 0px;margin-left:10px"
                      @click="cancelShare()"
                      v-if="sharedUser.uid"
                    >取消</el-button>
                  </el-col>
                </el-row>
                <el-row class="info-item">
                  <el-col :span="7" class="info-name">设备型号：</el-col>
                  <el-col :span="17">{{deviceInfo.model}}</el-col>
                </el-row>
                <el-row class="info-item">
                  <el-col :span="7" class="info-name">地址：</el-col>
                  <el-col :span="17">{{deviceInfo.fullAddress}}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <div v-if="deviceInfo.ntId!=1106">
              <el-row :gutter="20" style="margin-bottom:10px">
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{deviceInfo.online?'在线':'离线'}}({{waterPurifyInfo.csq}})</div>
                    <div class="info-frame_title">网络信号</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div class="info-frame_value">{{deviceInfo.remainingDays}}天</div>
                    <div class="info-frame_title">剩余天数</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{getStandardDate(new Date(deviceInfo.activationDate))}}</div>
                    <div class="info-frame_title">激活时间</div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom:10px">
                <el-col :span="6">
                  <div class="info-frame">
                    <div class="info-frame_value">{{waterPurifyInfo.totalWaterVolume/1000}}L</div>
                    <div class="info-frame_title">总用水量</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div class="info-frame_value">{{waterPurifyInfo.cleanWaterVolume/1000}}L</div>
                    <div class="info-frame_title">总净水量</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{getStandardDate(new Date(deviceInfo.expiresForDisplay))}}</div>
                    <div class="info-frame_title">显示到期日期</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="deviceInfo.ntId==1106">
              <el-row :gutter="20" style="margin-bottom:10px">
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{(waterPurifyInfo.preMembranePressure/1000000).toFixed(2)}} Mpa</div>
                    <div class="info-frame_title">膜前压力</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{(waterPurifyInfo.rawWaterPressure/1000000).toFixed(2)}} Mpa</div>
                    <div class="info-frame_title">原水压力</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div class="info-frame_value">{{waterPurifyInfo.oneTemp}} ℃</div>
                    <div class="info-frame_title">水温</div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom:10px">
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{descWaterTankLevel(waterPurifyInfo.waterTankLevel)}}</div>
                    <div class="info-frame_title">水箱水位</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div class="info-frame_value">{{waterPurifyInfo.runState>>8==1?'进行中':'停止'}}</div>
                    <div class="info-frame_title">杀菌状态</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="info-frame">
                    <div
                      class="info-frame_value"
                    >{{(waterPurifyInfo.cleanWaterVolume/1000).toFixed(2)}}L</div>
                    <div class="info-frame_title">出水流量</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <el-row :gutter="20" style="margin-bottom:10px">
              <el-col :span="6">
                <el-button type="primary" style="width:100%" @click="setNickname()">昵称设置</el-button>
              </el-col>
              <el-col :span="6" v-if="deviceInfo.status">
                <el-button type="primary" style="width:100%" @click="close()">关机</el-button>
              </el-col>
              <el-col :span="6" v-if="!deviceInfo.status">
                <el-button type="primary" style="width:100%" @click="open()">开机</el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="width:100%"
                  @click="optionChange(1)"
                  v-if="deviceInfo.ntId!=1106"
                >冲洗</el-button>
                <el-button
                  type="primary"
                  style="width:100%"
                  @click="washVisible=true"
                  v-if="deviceInfo.ntId==1106"
                >冲洗</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-bottom:10px" v-if="deviceInfo.ntId==1106">
              <el-col :span="6" v-if="waterPurifyInfo.runState>>8==0">
                <el-button type="primary" style="width:100%" @click="optionChange(14)">开始杀毒</el-button>
              </el-col>
              <el-col :span="6" v-if="waterPurifyInfo.runState>>8==1">
                <el-button type="primary" style="width:100%" @click="optionChange(15)">停止杀毒</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" style="width:100%" @click="openUvDialog()">自动杀毒</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="deviceInfo.ntId!=1106">
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="width:100%"
                  @click="dialogState.secondUnlock = true;secondUnlock.days=0;"
                >二次解锁</el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="width:100%"
                  v-if="isBrand"
                  @click="SyncExpiresDate()"
                >同步时间</el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="width:100%"
                  v-if="isAgent&&deviceInfo.rentStatus==0"
                  @click="renewal()"
                >续费</el-button>
                <el-button
                  type="primary"
                  style="width:100%"
                  v-if="isAgent&&deviceInfo.rentStatus==20"
                  @click="renewalByDay()"
                >续费</el-button>
              </el-col>

              <el-col :span="6" v-if="timerInfo!=null">
                <el-button type="primary" style="width:100%" @click="openTimingDialog">开机定时</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div class="layout" style="height:600px">
      <!-- 滤芯状态 -->
      <el-card style="grid-row: 1;grid-column: 1;">
        <div slot="header" class="clearfix">
          <span>滤芯状态</span>
        </div>
        <div v-for="(filter,index) in filters" style="margin-bottom:15px">
          <el-row>
            <el-col :span="20">
              <span>{{filter.name }}</span>
              <span
                style="margin-left:10px"
              >{{(filter.remainingtime>0?filter.remainingtime+"/"+filter.endtime:0)+"天"}}</span>
              <el-progress
                :text-inside="true"
                :stroke-width="20"
                :percentage="parseInt(filter.remainingtime>0?filter.remainingtime*100/filter.endtime:0)"
                style="margin-top:10px;"
              ></el-progress>
            </el-col>
            <el-col :span="4">
              <el-button
                style="background: #FFFFFF;border: 1px solid #16ACF0;opacity: 1;border-radius: 33px;align: center;line-height: 0px;margin-left:10px;margin-top:25px"
                @click="resetFilter(index+7)"
              >复位</el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card style="grid-row: 1;grid-column: 2;overflow-y:auto">
        <div slot="header" class="clearfix">
          <span>操作日志</span>
        </div>
        <div>
          <el-table :data="operationLogs.list">
            <el-table-column prop="operator" label="操作人"></el-table-column>
            <el-table-column prop="posttime" label="日期" :formatter="dateFormat"></el-table-column>
            <el-table-column prop="remark" label="事件"></el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align:right;margin-top: 15px;"
            @current-change="importantOperationLogPageChange"
            :current-page="operationLogs.page"
            :page-size="operationLogs.size"
            layout="total, prev, pager, next"
            :total="operationLogs.count"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <div>
      <el-dialog
        width="30%"
        :visible.sync="dialogState.secondUnlock"
        title="二次解锁"
        :close-on-click-modal="false"
      >
        <div style="margin-bottom: 20px;">
          <span>设备实际过期时间： {{ getStandardDate(new Date(deviceInfo.expires))}}</span>
        </div>
        <span>请输入解锁天数：</span>
        <el-input v-model="secondUnlock.days" style="width: 130px"></el-input>
        <div slot="footer">
          <el-button @click="submitSecondUnlock" type="primary">确定</el-button>
          <el-button @click="dialogState.secondUnlock = false">取消</el-button>
        </div>
      </el-dialog>
      <!--  按天续费弹窗  -->
      <el-dialog
        :visible.sync="dialogState.renewal"
        title="续费"
        width="28%"
        :close-on-click-modal="false"
      >
        <el-row style="margin-bottom:25px">
          <el-col :span="12">序列号: {{sn}}</el-col>
          <el-col :span="12">型号：{{ deviceInfo.model}}</el-col>
        </el-row>
        <el-row style="margin-bottom: 10px">
          <el-col :span="8">
            <el-button type="primary" style="width:100px" @click="renewalData.day=7">7天</el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" style="width:100px" @click="renewalData.day=30">一个月</el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" style="width:100px" @click="renewalData.day=365">一年</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 18px;text-align:right">
          <el-col :span="23">
            <el-input v-model="renewalData.day" style="width: 60%" type="number">
              <i slot="suffix" style="font-style:normal;">天</i>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="23" style="text-align: right;margin-bottom: 10px;">
            <strong style="font-size:large">
              合计：
              <span
                style="color: orange;"
              >{{Number(renewalData.day*renewalData.price).toFixed(2)}}</span>元
            </strong>
          </el-col>
        </el-row>
        <el-button
          type="primary"
          style="margin: 5px;width:95%; align-self: center"
          @click="submitRenewal"
        >续费</el-button>
      </el-dialog>
      <el-dialog title="操作" :visible.sync="washVisible" width="500px" :modal-append-to-body="false">
        <el-button type="primary" style="margin: 5px;width:100px" @click="optionChange(34)">超滤常规冲洗</el-button>
        <el-button type="primary" style="margin: 5px;width:100px" @click="optionChange(35)">超滤反冲洗</el-button>
        <el-button type="primary" style="margin: 5px;width:100px" @click="optionChange(36)">RO膜冲洗</el-button>
        <el-button type="primary" style="margin: 5px;width:100px" @click="optionChange(37)">整机冲洗</el-button>
      </el-dialog>
      <el-dialog
        title="设置定时杀毒"
        :visible.sync="uvVisible"
        width="500px"
        :modal-append-to-body="false"
      >
        <el-form label-position="right" label-width="80px">
          <el-form-item label="自动杀毒">
            <el-switch v-model="switchVal" active-color="#13ce66" inactive-color="#c0c0c0"></el-switch>
          </el-form-item>
          <el-form-item label="启动时间" v-if="switchVal">
            <el-time-picker v-model="selectDate" format="HH:mm" placeholder="任意时间点"></el-time-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="uvVisible = false">取消</el-button>
          <el-button type="primary" @click="setAutoSterilizeTime()">确定</el-button>
        </div>
      </el-dialog>
    </div>

    <div>
      <el-dialog width="30%" :visible.sync="timerDialog" title="开机定时" :close-on-click-modal="false">
        <el-form label-width="140px" :model="timerModel" :rules="timerRules" ref="timerModel">
          <el-form-item label="使能" prop="enable" required>
            <el-switch v-model="timerModel.enable" active-color="#bf4073"></el-switch>
          </el-form-item>
          <el-form-item label="开始时间" prop="start">
            <el-time-picker
              v-model="timerModel.start"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="请选择开始时间"
            ></el-time-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="stop">
            <el-time-picker
              v-model="timerModel.stop"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="请选择结束时间"
            ></el-time-picker>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="submitTimer" type="primary">确定</el-button>
          <el-button @click="timerDialog = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  request
} from '@/utils/request';
import axios from 'axios'
export default {
  components: {},
  props: {},
  data () {
    return {
      dialogState: {
        secondUnlock: false,
        renewal: false
      },
      renewalData: {
        day: 0,
        skuId: -1,
        price: 0.0,
        propertiesName: '',
        image: ''
      },
      secondUnlock: {
        days: 0
      },
      sharedUser: {},
      isBrand: false,
      isAgent: false,
      nid: 0,
      sn: '',
      deviceInfo: {},
      waterPurifyInfo: {
        "tdsValues": "[0,0]",
      },
      filters: [],
      operationLogs: {
        "list": [],
        "count": 0,
        "page": 1,
        "size": 5
      },
      washVisible: false,
      uvVisible: false,
      selectDate: "",
      switchVal: false,
      imgWidth: 0,
      imgHeight: 0,

      timerInfo: null,
      timerDialog: false,
      timerModel: {
        enable: false,
        start: '',
        stop: '',
      },
      timerRules: {
        start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        stop: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    descWaterTankLevel (level) {
      if (level == 1) {
        return '低'
      } else if (level == 2) {
        return '中'
      } else if (level == 3) {
        return '高'
      } else {
        return '未知'
      }
    },
    cancelShare () {
      request({
        url: '/srsDevice/cancelShare.do',
        method: 'get',
        params: {
          nid: this.nid,
          ouid: this.sharedUser.uid
        }
      }).then(res => {
        this.sharedUser = {};
        this.$message.success('操作成功');
      });
    },
    share () {
      this.$prompt('请输入手机号', '授权', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: '手机格式不正确'
      }).then(({
        value
      }) => {
        request({
          url: '/srsDevice/share.do',
          method: 'get',
          params: {
            nids: this.nid,
            phone: value
          }
        }).then(res => {
          this.listShareByNid();
          this.$message.success('设置成功');
        });
      })
    },
    listShareByNid () {
      request({
        url: '/srsDevice/listShareByNid.do',
        method: 'get',
        params: {
          nid: this.nid,
          size: 0
        }
      }).then(res => {
        if (res.data.length > 0) {
          this.sharedUser = res.data[0].oUser;
        }
      });
    },
    submitRenewal () {
      var thiz = this;
      const data = this.renewalData
      if (data.day <= 0) {
        this.$message.error("续费天数必须大于0")
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // const thiz = this;
      axios.get(this.$store.getters.getApiValue + '/order/generate.do', {
        params: {
          skuId: data.skuId,
          quantity: data.day,
          propertiesName: data.propertiesName,
          image: data.image,
          sn: thiz.sn
        }
      })
        .then(function (response) {
          const data = response.data
          if (data.status == '200') {
            if (data.data) {
              thiz.orderPay(data.data, loading)
            } else {
              thiz.$message.error('订单错误!请与管理员联系!')
              loading.close();
            }
          } else {
            thiz.$message.error(data.message);
            loading.close();
          }
        })
        .catch(function (error) {
          loading.close()
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    orderPay (orderId, loading) {
      const thiz = this
      axios
        .get(this.$store.getters.getApiValue + '/order/pay.do', {
          params: {
            orderId: orderId
          }
        })
        .then(function (res) {
          if (res.data) {
            setTimeout(() => {
              thiz.getDeviceInfo();
              thiz.listImportantOperationLog();
              thiz.$message.success('续费成功，数据有延迟，如过期时间不对，请在1分钟后再查看');
              thiz.dialogState.renewal = false;
              loading.close();
            }, 3000)
          } else {
            thiz.dialogState.renewal = false;
            loading.close();
            thiz.$message.error('续费失败');
          }
        })
        .catch(function (error) {
          thiz.renewalVisible = false
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    renewalByDay () {
      var thiz = this;
      request({
        url: '/product/getProductByDevice.do',
        method: 'get',
        params: {
          sn: thiz.sn,
          cid: 20,
          queryJson: '[{"key":"charge_items","value":"1"}]'
        }
      }).then(res => {
        thiz.renewalData.skuId = res.data.skuProductList[0].skuId
        thiz.renewalData.price = res.data.skuProductList[0].price
        thiz.renewalData.image = res.data.mainImage[0]
        thiz.renewalData.propertiesName = res.data.skuProductList[0].propertiesName
        thiz.dialogState.renewal = true;
      });
    },
    renewal () {
      var thiz = this;
      this.$confirm(
        '确认为客户' +
        this.deviceInfo.companyName +
        '续期设备条形码为“' +
        this.sn +
        '”的设备吗?'
      )
        .then(_ => {
          const loading = this.$loading({
            lock: true,
            text: '操作执行中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          const thiz = this;
          axios.get(this.$store.getters.getApiValue + '/srsDevice/deviceRenewal.do', {
            params: {
              nid: thiz.nid
            }
          })
            .then(function (response) {
              const data = response.data
              if (data.status == '200') {
                if (data.data) {
                  setTimeout(() => {
                    thiz.$message.success(
                      '续期成功!数据有延迟，请在1分钟后刷新页面进行查看到期时间!'
                    )
                    thiz.getDeviceInfo();
                    thiz.listImportantOperationLog();
                    loading.close();
                  }, 3000)
                } else {
                  thiz.$message.error('订单错误!请与管理员联系!')
                  loading.close();
                }
              } else {
                thiz.$message.error(data.message);
                loading.close();
              }
            })
            .catch(function (error) {
              loading.close()
              console.log(error)
              thiz.$message.error('系统异常!请与管理员联系!')
            })
        })
    },
    submitSecondUnlock () {
      var thiz = this;
      request({
        url: '/srsDevice/secondUnlock.do',
        method: 'get',
        params: {
          nid: this.nid,
          days: this.secondUnlock.days
        }
      }).then(res => {
        this.getDeviceInfo();
        thiz.$message.success("执行成功");
        thiz.dialogState.secondUnlock = false;
      });
    },
    setNickname (nid) {
      var thiz = this;
      this.$prompt('请输入新设备名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '不能为空'
      }).then(({
        value
      }) => {
        request({
          url: '/srsDevice/updateNickname.do',
          method: 'get',
          params: {
            nid: this.nid,
            nickname: value
          }
        }).then(res => {
          this.deviceInfo.nickname = value;
        });
      })
    },
    getMyData () {
      request({
        url: '/srsUser/getMyData.do',
        method: 'get',
        params: {}
      }).then(res => {
        let role = res.data.role;
        if (role == 4) {
          this.isBrand = true;
        } else if (role == 2 || role == 3 || role == 8) {
          this.isAgent = true;
        }
      });
    },
    importantOperationLogPageChange (pageId) {
      this.operationLogs.page = pageId;
      this.listImportantOperationLog();
    },
    listImportantOperationLog () {
      request({
        url: '/srsDevice/listImportantOperationLog.do',
        method: 'get',
        params: {
          nid: this.nid,
          pageId: this.operationLogs.page,
          size: this.operationLogs.size
        }
      }).then(res => {
        this.operationLogs.list = res.data;
        this.operationLogs.count = res.totalCount;
      });
    },
    optionChange (action) {
      request({
        url: '/smartWaterPurify/operate.do',
        method: 'get',
        params: {
          nid: this.nid,
          action: action,
          sync: true
        }
      }).then(res => {
        if (res) {
          if ("success" == res.data) {
            this.$message.success("执行成功");
            if (this.deviceInfo.ntId == 1106) {
              let mask = 1 << 8;
              if (action == 14) {
                this.waterPurifyInfo.runState |= mask
              } else if (action == 15) {
                this.waterPurifyInfo.runState &= (~mask)
              }
            }
            console.log(this.waterPurifyInfo.runState)
          } else {
            this.$message.error("执行失败");
          }
        }
      });
    },
    openUvDialog () {
      this.switchVal = this.waterPurifyInfo.autoSterilizeTime > 0;
      let now = new Date();
      this.selectDate = new Date(now.getYear(), now.getMonth(), now.getDate(), this.waterPurifyInfo.autoSterilizeTime / 60, this.waterPurifyInfo.autoSterilizeTime % 60)
      this.uvVisible = true;
    },
    setAutoSterilizeTime () {
      let actionValue = this.switchVal ? this.selectDate.getHours() * 60 + this.selectDate.getMinutes() : 0;
      request({
        url: '/smartWaterPurify/setParam.do',
        method: 'get',
        params: {
          nid: this.nid,
          action: 52,
          actionValue,
          sync: true
        }
      }).then(res => {
        if (res) {
          if ("success" == res.data) {
            this.$message.success("执行成功");
            this.waterPurifyInfo.autoSterilizeTime = actionValue;
            this.uvVisible = false;
          } else {
            this.$message.error("执行失败");
          }
        }
      }).catch(res => {

      });
    },
    SyncExpiresDate (action) {
      request({
        url: '/srsDevice/SyncExpiresDate.do',
        method: 'get',
        params: {
          nid: this.nid,
          sync: true
        }
      }).then(res => {
        this.$message.success("执行成功");
      });
    },
    resetFilter (action) {
      this.$confirm('此操作将重置滤芯, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/smartWaterPurify/operate.do',
          method: 'get',
          params: {
            nid: this.nid,
            action: action,
            sync: true
          }
        }).then(res => {
          this.$message.success("执行成功");
          this.getWaterPurifyInfo();
        });
      }).catch(() => { });
    },
    open () {
      request({
        url: '/srsDevice/open.do',
        method: 'get',
        params: {
          nid: this.nid,
          sync: true
        }
      }).then(res => {
        this.$message.success("执行成功");
        this.deviceInfo.status = true;
      });
    },
    close () {
      request({
        url: '/srsDevice/close.do',
        method: 'get',
        params: {
          nid: this.nid,
          sync: true
        }
      }).then(res => {
        this.$message.success("执行成功");
        this.deviceInfo.status = false;
      });
    },
    getDeviceInfo () {
      request({
        url: '/srsDevice/searchMyDevice.do',
        method: 'get',
        params: {
          rentStatus: -1,
          sn: this.sn
        }
      }).then(res => {
        this.deviceInfo = res.data[0];
        this.deviceInfo.remainingDays = Math.ceil((this.deviceInfo.expires - (new Date()
          .getTime())) / 86400000);
        if (this.deviceInfo.remainingDays < 0) {
          this.deviceInfo.remainingDays = 0;
        }
      });
    },
    getWaterPurifyInfo () {
      request({
        url: '/smartWaterPurify/getInfo.do',
        method: 'get',
        params: {
          nid: this.nid
        }
      }).then(res => {
        this.waterPurifyInfo = res.data;
        if (this.waterPurifyInfo.filterNames && this.waterPurifyInfo.filterRunTimes != "[]") {
          let fnArray = this.waterPurifyInfo.filterNames.split(",");
          let frtArray = JSON.parse(this.waterPurifyInfo.filterRunTimes);
          let fetArray = JSON.parse(this.waterPurifyInfo.filterEndTimes);
          for (let i = 0; i < fnArray.length; i++) {
            this.filters.push({
              "name": fnArray[i],
              "remainingtime": Math.ceil((fetArray[i] - frtArray[i]) / 86400),
              "endtime": Math.ceil(fetArray[i] / 86400)
            });
          }
        }
      });
    },
    dateFormat (row, column, cellValue, index) {
      var str = cellValue
      if (str == null || str == '') {
        return ''
      } else {
        return this.getStandardSecond(new Date(str))
      }
    },
    getStandardDate (val) {
      if (val == null) {
        return '-'
      }
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day
    },
    getStandardSecond (time) {
      return `${time.getFullYear()}-${time.getMonth() + 1 >= 10 ? (time.getMonth() + 1) : '0' + (time.getMonth() + 1)}-${time.getDate() >= 10 ? time.getDate() : '0' + time.getDate()}  ${time.getHours() >= 10 ? time.getHours() : '0' + time.getHours()} : ${time.getMinutes() >= 10 ? time.getMinutes() : '0' + time.getMinutes()} : ${time.getSeconds() >= 10 ? time.getSeconds() : '0' + time.getSeconds()}`;
    },
    usernameToPhone (username) {
      if (username) {
        let index = username.indexOf("_") + 1;
        return username.substr(index, username.length);
      } else {
        return "";
      }

    },
    setSize (e, maxWidth, maxHeight) {
      const width = e.target.naturalWidth
      const height = e.target.naturalHeight
      let wratio = width * 1.0 / maxWidth;
      let hratio = height * 1.0 / maxHeight;
      let ratio = width * 1.0 / height;
      if (wratio >= hratio) {
        this.imgWidth = maxWidth;
        this.imgHeight = this.imgWidth * 1.0 / ratio
      } else {
        this.imgHeight = maxHeight;
        this.imgWidth = this.imgHeight * ratio;
      }
    },

    getDailyOpenTimer () {
      request({
        url: '/srsDevice/getDailyOpenTimer.do',
        method: 'get',
        params: {
          nid: this.nid
        }
      }).then(res => {
        if (res.data != null) {
          this.timerInfo = res.data
        }
      })
    },

    openTimingDialog () {
      this.getDailyOpenTimer()
      let info = this.timerInfo
      if (info != null) {
        this.timerModel = {
          enable: info.enable,
          start: this.convertMinutesToHHMM(info.start),
          stop: this.convertMinutesToHHMM(info.stop),
        }
      } else {
        this.timerModel = {
          enable: false,
          start: '',
          stop: '',
        }
      }
      this.timerDialog = true
    },

    convertMinutesToHHMM (totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },

    submitTimer () {
      let thiz = this
      let params = JSON.parse(JSON.stringify(this.timerModel))
      params.nid = this.nid
      let start = params.start.split(':')
      let stop = params.stop.split(':')
      params.start = Number(start[0]) * 60 + Number(start[1])
      params.stop = Number(stop[0]) * 60 + Number(stop[1])
      params.sync = true
      this.$refs['timerModel'].validate((valid) => {
        if (valid) {
          request({
            url: '/srsDevice/setDailyOpenTimer.do',
            method: 'post',
            params: params
          }).then(res => {
            if (res.data == 'success') {
              thiz.$message.success("操作成功");
              thiz.timerDialog = false;
            } else {
              thiz.$message.error("操作失败");
            }
          })
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    }
  },
  created () {

  },
  mounted () {
    this.nid = this.$route.query.nid;
    this.sn = this.$route.query.sn;
    this.getMyData();
    this.getDeviceInfo();
    this.getWaterPurifyInfo();
    this.listImportantOperationLog();
    this.listShareByNid();
    this.getDailyOpenTimer()
  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
}
</script>
<style scoped>
* {
  font-size: 13px;
}

.card {
  opacity: 1;
  border-radius: 8px;
}

.cardFont {
  padding-top: 4%;
  padding-bottom: 4%;
  margin-top: 1%;
  text-align: center;
  font-family: Segoe UI;
  font-weight: bold;
  color: #ffffff;
  opacity: 1;
}

.info-name {
  text-align: left;
  color: rgb(158, 157, 157);
}

.info-item {
  padding-bottom: 15px;
}

.info-frame {
  widows: 110px;
  height: 50px;
  text-align: center;
  border: 2px solid #dadada;
  border-radius: 8px;
}

.info-frame_value {
  color: #076baf;
  font-weight: bold;
  padding-top: 5px;
  font-size: 15px;
}

.info-frame_title {
  color: #7a7a7a;
  font-size: 11px;
  padding-top: 10px;
}

.layout {
  margin-top: 15px;
  position: relative;
  width: 100%;
  display: grid;
  overflow: hidden;
  grid-template-columns: 35% 65%;
  grid-auto-rows: 460px 460px;
  grid-gap: 15px;
}

.el-progress-bar {
  float: left;
}
</style>
